module.exports = __webpack_public_path__ + "img/Girl_010011.ff556d1c.png";